module.exports = "//static.hsappstatic.net/LoginUI/static-1.14996/img/donut_mobile.svg"